// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__xpL53","modalForm":"UpgradeEpcsModal_modalForm__3dvi2","modalFooter":"UpgradeEpcsModal_modalFooter__2ra6y"};